import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import fr from './locales/fr/common.json'
import de from './locales/de/common.json'
import en from './locales/en/common.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'de', 'en'],
    resources: {
      fr: { common: fr },
      de: { common: de },
      en: { common: en }
    },
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false }
  })

export default i18n
